<template>
  <VWidget
    :title="$t('Settings')"
  >
    <div slot="widget-header-action">
      <v-switch
        slot="activator"
        v-model="product.inventory.is_available"
        :label="$t('Available')"
        class="mt-4"
        color="primary"
      />
    </div>
    <v-layout
      slot="widget-content"
      row
      wrap
    >
      <v-flex xs12>
        <v-select
          v-model="product.classification"
          :items="['common', 'bundle']"
          :label="$t('Product classification')"
          :disabled="editMode"
          outline
        />
        <v-select
          v-model="product.type"
          :items="['virtual', 'physical', 'digital']"
          :label="$t('Product type')"
          outline
        />
        <v-text-field
          v-model="product.brand"
          :label="$t('Brand')"
          outline
        />
        <v-text-field
          v-if="product.taxonomy"
          v-model="product.taxonomy.name"
          :label="$t('Taxonomy')"
          outline
          @click="$emit('select-taxonomy')"
        />
        <!-- TODO properly fix this when taxonomy is not present -->
        <v-text-field
          v-else
          :label="$t('Taxonomy')"
          outline
          @click="$emit('select-taxonomy')"
        />
        <v-text-field
          v-model.number="product.order"
          :label="$t('Sort order')"
          mask="######################"
          outline />
      </v-flex>
    </v-layout>
  </VWidget>
</template>

<script>

export default {
  name: 'ProductSingleOrganization',

  props: {
    product: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      model: [],
      search: null,
      items: [],
      loading: false
    }
  },

  methods: {
    filter (item, queryText, itemText) {
      const hasValue = val => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      )
    }
  }
}
</script>
